import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: "root",
})
export class MyspinnerService {
  constructor(private spinner: NgxSpinnerService) {}

  showSpinner() {
    // Shared full-screen spinner remains disabled; pages use scoped loaders.
  }

  hideSpinner() {
    this.spinner.hide();
  }
}
